const config = {
  httpLinkUrl:
    process.env.REACT_APP_HTTP_LINK || 'http://localhost:8085/v1/graphql',
  wsLinkUrl: process.env.REACT_APP_WS_LINK || 'ws://localhost:8085/v1/graphql'
}

export default config
